import { get, } from "@/api/axios";

// 获取banner列表
export const list = params => get('/web/deposit/record/list', params);



